<template>
    <div class = "print" v-if="getPermission.loads.view || getPermission.stc.view || getPermission.stcExtraCost.view">

        <md-tabs md-sync-route class="load-and-bill-tabs">
          <!--
          <md-tab id="tab-yard-export" md-label="Yard Export" to="/dispatch/yardExport"></md-tab>
          <md-tab id="tab-direct-export" md-label="Export" to="/dispatch/directExport"></md-tab>
          <md-tab id="tab-import" md-label="Import" to="/dispatch/import"></md-tab>
          <md-tab id="tab-truck-load" md-label="Truck Load" to="/dispatch/truckLoad"></md-tab>
          -->
          <!-- <md-tab id="tab-test" md-label="test" to="/dispatch/test"></md-tab> -->
          <!--
          <md-tab id="tab-dispatch_load" md-label="Load" to="/dispatch/load"></md-tab>
          <md-tab id="tab-dispatch_stage" md-label="Stage" to="/dispatch/stage"></md-tab>
          -->
        </md-tabs>
        <router-view/>

    </div>

</template>

<style lang="scss">


  .load-and-bill-tabs {
    .md-tabs-navigation {
      .md-theme-default {
        height: 30px;
      }
    }
  }

  


</style>


<script>
  import { mapGetters } from 'vuex';

  export default {
    data: () => ({}),
    computed: {
      ...mapGetters([
        'getPermission',
        'getMasterDataName',
      ]),
    },
  };

</script>



